import { Box, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { FC } from "react";

export interface ChemicalElementOption {
  value: number;
  label: string;
}

interface MaterialOverridesFilterProps {
  label: string;
  allLabel: string;
  selectedChemicalElementId: number | null;
  options: ChemicalElementOption[];
  onChange: (value: number | null) => void;
}

export const MaterialOverridesFilter: FC<MaterialOverridesFilterProps> = ({
  label,
  allLabel,
  selectedChemicalElementId,
  options,
  onChange,
}) => {
  return (
    <Box
      id="material-overrides-filter-panel"
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        pt: 1,
        minHeight: 40,
      }}
    >
      <FormControl size="small" sx={{ minWidth: 200 }}>
        <InputLabel id="chemical-element-filter-label">{label}</InputLabel>
        <Select<number | "">
          labelId="chemical-element-filter-label"
          value={selectedChemicalElementId ?? ""}
          label={label}
          onChange={(event) => {
            onChange(event.target.value === "" ? null : event.target.value);
          }}
        >
          <MenuItem value="">
            <em>{allLabel}</em>
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
